import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatExpansionPanel } from "@angular/material/expansion";
import { ITranslation } from "@comunicare/comunicare-interfaces";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged, takeUntil, tap } from "rxjs/operators";
import { defaultLangValidator } from "src/app/careplan-editor/domain/careplan-template-form-helper";

@Component({
  selector: "app-translation-form",
  templateUrl: "./translation-form.component.html",
  styleUrls: ["./translation-form.component.scss"],
})
export class TranslationFormComponent implements OnDestroy, OnInit {
  @Input() formGroup: UntypedFormGroup;
  @Input() translationsFormArray: UntypedFormArray;
  @Input() availableLangs: ITranslation[];
  @Input() placeholder: string;
  @Output() keystroke: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild(MatExpansionPanel) panel: MatExpansionPanel;

  private onDestroy$ = new Subject<void>();

  public ngOnInit(): void {
    // Add validator to check that the default language has a translation
    setTimeout(() => {
      this.formGroup.addValidators(defaultLangValidator());
    });

    // Detect keystrokes in order to trigger the refresh of the pipe getActivityName()
    this.formGroup.valueChanges
      .pipe(
        takeUntil(this.onDestroy$),
        debounceTime(150),
        distinctUntilChanged(),
        tap((value) => {
          this.keystroke.emit(value.translations[0].translateKey);
        })
      )
      .subscribe();
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  /**
   * Add a translation (in a language not already set) for form field
   */
  public addTranslation(): void {
    const notAlreadyUsedLang = this.availableLangs.filter((l) => {
      const langs: string[] = this.translationsFormArray.value.map((d) => d.lang);
      return !langs.includes(l.term);
    });
    this.translationsFormArray.push(
      new UntypedFormGroup({
        translateKey: new UntypedFormControl("", Validators.required),
        lang: new UntypedFormControl(notAlreadyUsedLang[0]?.term),
      })
    );
  }

  /**
   * remove a translation from form field
   */
  public deleteTranslation(index: number): void {
    this.translationsFormArray.removeAt(index);
  }

  public openPanel(): void {
    setTimeout(() => {
      if (this.panel) {
        this.panel.open();
      }
    });
  }
}
